import { request, qs } from './api';

// Place ⇄ activity-category mappings + their moderation flow.
// All endpoints require the admin JWT (handled by request()).

// GET /admin/place-activities?page&limit&search -> { data:[Row], total, page, limit }
// Un-moderated mappings only (the moderation queue).
export const listPlaceActivityQueue = (params) =>
  request(`/place-activities${qs(params)}`);

// GET /admin/place-activities/all?page&limit&moderated&search -> { data:[Row], total, page, limit }
// Every mapping; `moderated` (true|false) narrows it, omit for all.
export const listAllPlaceActivities = (params) =>
  request(`/place-activities/all${qs(params)}`);

// GET /admin/activities -> { data:[{ id, ref_id, name, icon }] }
// Master activity catalog for the multi-select picker.
export const listActivityCatalog = () => request('/activities');

// POST /admin/place-activities { name, place_type?, activities:number[] } -> 201 { data: Row }
// 409 when the name already exists (caller should tell the user to edit instead).
export const createPlaceActivity = (body) =>
  request('/place-activities', { method: 'POST', body });

// POST /admin/place-activities with an ARRAY body — batch upsert + moderate.
// [{ place_name, place_type?, place_id?, activities:number[], moderated? }, ...]
export const savePlaceActivities = (items) =>
  request('/place-activities', { method: 'POST', body: items });

// PUT /admin/place-activities/:id { activities:number[], place_type? } -> { data: Row }
// Also marks the mapping moderated.
export const updatePlaceActivity = (id, body) =>
  request(`/place-activities/${id}`, { method: 'PUT', body });

// POST /admin/place-activities/moderate { ids:number[], moderated?:boolean }
// -> { data:{ updated, not_found, moderated, count } }. moderated defaults to true.
export const moderatePlaceActivities = (ids, moderated = true) =>
  request('/place-activities/moderate', { method: 'POST', body: { ids, moderated } });
